import React, { useState } from "react";
import styles from "./index.module.css";
import { motion } from "framer-motion";
import Tabs from "../Tabs";
import OrganizingTeamData from "../../data/organizationTeams.js";

const OrganizingTeam = () => {
    const [activeTab, setActiveTab] = useState("Australian");

    const tabsItems = [
        { label: "Australia Delegates", value: "Australian" },
        { label: "Indian Team", value: "Indian" },
    ];

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
            <h2 className="heading">Organizing Team</h2>
            <div className="flex justify-center mb-6">
                <Tabs data={{ activeTab, setActiveTab, tabsItems }} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
                {OrganizingTeamData.filter((item) => item.country === activeTab).map((organizer, index) => (
                    <motion.div
                        key={organizer.name}
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            duration: 0.8,
                            // , delay: index * 0.1
                        }}
                        className="text-center mt-7"
                    >
                        <div className="relative w-48 h-48 mx-auto mb-4">
                            <img src={organizer.image} alt={organizer.name} width={200} height={200} style={{ height: "100%" }} className="rounded-full" />
                            <div className="absolute bottom-0 right-0 bg-indigo-600 text-white px-3 py-1 rounded-full text-sm">{organizer.country}</div>
                        </div>
                        <h3 className="text-xl font-semibold">{organizer.name}</h3>
                        <p className="text-indigo-600">{organizer.role}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default OrganizingTeam;
